export const snlaCbConfig = () => {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const isEnglishPath = /^\/en(?:\/|$)/i.test(pathname);

    // CookieBot ID
    const config = {
        cbid: '4092afc9-d60d-48d5-be80-b5fb79df97cc',
        culture: isEnglishPath ? 'EN' : 'NO'
    };

    /*
        Matomo Tag Manager container ID based on the environment (localhost, staging, production)
        norskluftambulanse.no
        norskluftambulanse.no/akutt-abc-2/
        norskluftambulanse.no/nodplakat/
    */
    const containerByOrigin = {
        'http://localhost:7889': 'F3eMEsgY', // n16e
        'http://localhost:7979': 'F3eMEsgY', // nødplakat
        'http://localhost:3000': 'F3eMEsgY', // akutt-abc
        'https://stage.n16e.no': 'ODlaopPV',
        'https://www.norskluftambulanse.no': 'rbLU4Bkp' // default container ID
    };

    config.container_id = containerByOrigin[origin] ?? 'rbLU4Bkp';

    return config;
};
